export default {
    open,
    registerTemplate,
    dismiss,
}

let promiseResolve;
let promise = new Promise((resolve, reject) => {
    promiseResolve = resolve;
});
let _template;
let currentModal = null;
function open(component, props = {}, listeners = {}, classes = [], waitForYesFromPreviousModal = false) {
    if (currentModal && component === currentModal.component) {
        // component already (waiting to be) displayed
        return;
    }
    if (currentModal) {
        if (waitForYesFromPreviousModal) {
            // wait for current modal to be closed, then reexecute open(); if dismissed, dont open()
            currentModal.result.then(() => open(component, props, listeners, classes));
            return;
        } else {
            currentModal.dismiss();
            currentModal = null;
        }
    }
    if (!_template) {
        // not registered yet; return a dummy object, which will be filled once
        // the template gets registerd and the promise resolves
        currentModal = {
            component,
        };
        // wait for promise to resolve
        promise.then(() => {
            let modal = _template.open(component, props, listeners, classes);
            currentModal.close = modal.close;
            currentModal.dismiss = modal.dismiss;
            currentModal.result = modal.result;
            currentModal.result.finally(() => currentModal = null);
        });
        return currentModal;
    } else {
        currentModal = _template.open(component, props, listeners, classes);
        currentModal.component = component;
        currentModal.result.finally(() => currentModal = null);
    }
    return currentModal;
}

function dismiss() {
    currentModal?.dismiss();
    currentModal = null;
}

function registerTemplate(template) {
    _template = template;
    // signal the promise that template has been registered
    promiseResolve(template);
}
